import { Alert } from 'antd';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';
import type { ToolbarSlot, TransformToolbarSlot } from '@react-pdf-viewer/toolbar';

export const PdfViewer = (props: { url?: string; restrictMode?: boolean; onLoad?: () => void }) => {

    const toolbarPluginInstance = toolbarPlugin();
    const { renderDefaultToolbar, Toolbar } = toolbarPluginInstance;

    const transform: TransformToolbarSlot = (slot: ToolbarSlot) => {
        if (props.restrictMode === true) {
            slot.Download = () => <></>;
            slot.DownloadMenuItem = () => <></>;

        }
        slot.Print = () => <></>;
        slot.PrintMenuItem = () => <></>;
        slot.Open = () => <></>;
        slot.OpenMenuItem = () => <></>;
        return {
            ...slot
        };
    };

    return (
        props.url ?
            <Worker workerUrl={'pdf.worker.min.js'}>
                <div
                    style={{
                        direction: 'ltr',
                        alignItems: 'center',
                        backgroundColor: '#eeeeee',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                        display: 'flex',
                        padding: '0.25rem',
                    }}
                >
                    <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
                </div>
                <Viewer
                    fileUrl={props.url}
                    plugins={[toolbarPluginInstance]}
                    onDocumentLoad={props.onLoad}

                />
            </Worker>
            : <Alert message={'فایل یافت نشد'} type='warning' showIcon />
    );
}